import {getFabricImageFromURL, getIconColors, getImageTypeFromURL} from "./helpers";
import {fabric} from "fabric";

export const addArtImage = (imgItem, left, top, canvas, objId, activeSheet, isCropped = false) => {
    let imgType = getImageTypeFromURL(imgItem)


    return new Promise(function (resolve, reject) {
        const uuid = require("uuid");
        let id = uuid.v4();

        if (imgType === 'image/svg+xml') {
            fabric.loadSVGFromURL(imgItem, (objects, option) => {
                const obj = fabric.util.groupSVGElements(objects, option);

                let tempHeight = obj.height;
                let tempWidth = obj.width;

                if (tempHeight >= tempWidth) {
                    obj.scaleToHeight(100)
                } else {
                    obj.scaleToWidth(100)
                }
                let custom = {
                    id: uuid.v4(),
                    type: "svg",
                    url: imgItem,
                };

                obj.set({
                    custom,
                    originalSrc: imgItem,
                    item_id: objId,
                    name: 'svg',
                    left: left,
                    top: top,
                });
                let svgColorArray = getIconColors(obj, 'fill'),
                    svgStrokeArray = getIconColors(obj, 'stroke');

                let filteredColors = [];
                svgColorArray.map((color) => {
                    if (!filteredColors.find((col) => col.color === color.value))
                        filteredColors.push({index: color.id, color: color.value})
                })
                obj.set({
                    svgColorArray: svgColorArray,
                    svgStrokeArray: svgStrokeArray,
                })
                canvas.add(obj).setActiveObject(obj).renderAll();
                resolve(obj)
            });
        } else {
            getFabricImageFromURL(imgItem, async (imgInstance) => {
                imgInstance.set({
                    left: left,
                    top: top,
                    name: 'art-work',
                    id: id,
                    item_id: objId,
                    isLockMovement: false,
                    actualDim: 0,
                    originalSrc: imgItem,
                });

                !isCropped && imgInstance.scaleToWidth(200)

                canvas.add(imgInstance);
                canvas.setActiveObject(imgInstance)
                canvas.renderAll()
                resolve(imgInstance)
            });
        }
    })
}
